module.exports = __webpack_public_path__ + "img/lp-climate-change.bb772309.svg";